import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-10 px-6 bg-charcoal" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <p className="text-cream/60 text-sm mb-6 text-center" data-id="element-47">
            Este protocolo es informativo y no sustituye el consejo médico
            profesional.
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-48">
            <button onClick={() => setShowPrivacy(true)} className="text-cream/50 text-sm hover:text-cream transition-colors underline underline-offset-2" data-id="element-49">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-50">|</span>
            <button onClick={() => setShowTerms(true)} className="text-cream/50 text-sm hover:text-cream transition-colors underline underline-offset-2" data-id="element-51">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-cream/30 text-xs text-center" data-id="element-52">
            &copy; {new Date().getFullYear()} Protocolo Flash Anti-Inflamación.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-53">
        <p className="font-semibold text-charcoal" data-id="element-54">
          Última actualización: Febrero 2026
        </p>

        <p data-id="element-55">
          Tu privacidad es importante para nosotros. Esta Política de Privacidad
          describe cómo recopilamos, usamos y protegemos tu información personal
          cuando adquieres y utilizas el Protocolo Flash Anti-Inflamación 48H.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-56">
          1. Información que recopilamos
        </h4>
        <p data-id="element-57">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar tu pedido: nombre, dirección de correo electrónico y
          datos de pago. Los datos de pago son procesados de forma segura por
          nuestro proveedor de pagos y nunca almacenamos información de tarjetas
          de crédito.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-58">
          2. Uso de la información
        </h4>
        <p data-id="element-59">
          Utilizamos tu información exclusivamente para: entregar el producto
          digital adquirido, enviarte el recibo de compra y, si lo autorizas,
          comunicarte actualizaciones relevantes sobre el protocolo.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-60">3. Protección de datos</h4>
        <p data-id="element-61">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-62">
          4. Compartir información
        </h4>
        <p data-id="element-63">
          No vendemos, comercializamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación del sitio web y el procesamiento de pagos.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-64">5. Cookies</h4>
        <p data-id="element-65">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto podría afectar algunas funcionalidades del sitio.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-66">6. Tus derechos</h4>
        <p data-id="element-67">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la cancelación
          de comunicaciones comerciales.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-68">
        <p className="font-semibold text-charcoal" data-id="element-69">
          Última actualización: Febrero 2026
        </p>

        <p data-id="element-70">
          Al adquirir el Protocolo Flash Anti-Inflamación 48H, aceptas los
          siguientes términos y condiciones. Por favor, léelos detenidamente
          antes de completar tu compra.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-71">1. Producto digital</h4>
        <p data-id="element-72">
          El Protocolo Flash Anti-Inflamación 48H es un producto digital en
          formato PDF que se entrega de forma inmediata tras la confirmación del
          pago. No se realizan envíos físicos.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-73">2. Uso personal</h4>
        <p data-id="element-74">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, modificación o reventa
          total o parcial del material sin autorización expresa por escrito.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-75">
          3. Garantía de satisfacción
        </h4>
        <p data-id="element-76">
          Ofrecemos una garantía de satisfacción de 7 días a partir de la fecha
          de compra. Si no estás satisfecha con el producto, puedes solicitar un
          reembolso completo dentro de este período.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-77">
          4. Descargo de responsabilidad médica
        </h4>
        <p data-id="element-78">
          Este protocolo tiene fines informativos y educativos únicamente. No
          constituye consejo médico, diagnóstico ni tratamiento. Consulta
          siempre con un profesional de la salud antes de iniciar cualquier
          cambio en tu alimentación, especialmente si tienes condiciones médicas
          preexistentes, estás embarazada o en período de lactancia.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-79">5. Resultados</h4>
        <p data-id="element-80">
          Los resultados pueden variar de persona a persona. Las cifras y
          beneficios mencionados se basan en principios de nutrición funcional y
          no garantizan resultados específicos para cada individuo.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-81">
          6. Propiedad intelectual
        </h4>
        <p data-id="element-82">
          Todo el contenido, incluyendo textos, gráficos, diseños y metodologías
          como el "Sistema 3R Express™", está protegido por derechos de
          propiedad intelectual.
        </p>

        <h4 className="font-bold text-charcoal mt-4" data-id="element-83">7. Modificaciones</h4>
        <p data-id="element-84">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </LegalModal>
    </>;
}